/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/LoginServicerForm.module.css';
import { useLoginServicerContext } from '../../contexts/LoginServicerPageContext';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useId } from 'react';
import LoadingModal from '../modals/LoadingModal';

export const LoginServicerForm = () => {
  const { fields, errors, isSubmitting, handleChange, handleSubmit } = useLoginServicerContext();
  const emailId = useId();
  const passwordId = useId();

  return (
    <section className={Styles.class}>
      <h1 className='sr-only'>Login</h1>
      <form onSubmit={handleSubmit}>
        <fieldset>
          <label htmlFor={emailId}>Email: *</label>
          <input type='text' inputMode='email' name='email' value={fields.email} onChange={handleChange} required />
          {errors.email && <small>{errors.email}</small>}
        </fieldset>

        <fieldset>
          <label htmlFor={passwordId}>Password: *</label>
          <div>
            <input
              type={fields.isPasswordVisible ? 'text' : 'password'}
              name='password'
              value={fields.password}
              onChange={handleChange}
              required
            />
            <button
              type='button'
              name='isPasswordVisible'
              value={fields.isPasswordVisible ? '' : 'true'}
              onClick={handleChange}
            >
              {fields.isPasswordVisible ? <VisibilityOff /> : <Visibility />}
            </button>
          </div>
          {errors.password && <small>{errors.password}</small>}
        </fieldset>

        <p>Required fields are indicated by *</p>

        {errors.generic && <small>{errors.generic}</small>}

        <button type='submit' disabled={isSubmitting}>
          Login
        </button>
      </form>

      <LoadingModal open={isSubmitting} loadingMessage={'Logging In'} />
    </section>
  );
};

export default LoginServicerForm;
